import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import ForbiddenAccessTable from 'Components/ForbiddenAccessTable';
import { User } from 'Interfaces/User';
import { selectUser } from 'Utils/selectors';

interface SettingsGuardLayoutProps {
  element: ReactNode;
  guard: (user: User) => boolean;
}

const SettingsGuardLayout = ({ element, guard }: SettingsGuardLayoutProps) => {
  const user: User = useSelector(selectUser);
  return guard(user) ? <>{element}</> : <ForbiddenAccessTable />;
};

export default SettingsGuardLayout;
